export default __webpack_public_path__ + "static/media/reception-bg.5d915299.png";